import { Button, styled } from "@mui/material";
import { useShopifyCheckoutControllerCreateCheckout } from "../../services/generated";
import { CartItem } from "../../store/cartSlice";

type BuyButtonProps = {
  items: CartItem[];
};

const StyledButton = styled(Button)({
  backgroundColor: "#000",
  color: "white",
  flexGrow: 1,
  minWidth: "clamp(100px, 40%, 200px)", 

  padding: "clamp(6px, 1vh, 10px) clamp(12px, 3vw, 24px)",
  fontSize: "clamp(0.7rem, 1.5vw, 1rem)",

  "&:hover": {
    backgroundColor: "#333",
  },

  textDecoration: "none",
  transition: "color 0.3s ease",
  borderColor: "black",
  border: "1px solid #1A1A1A",
  borderRadius: "999px",
  textTransform: "capitalize",
  borderWidth: "1px",
});

const BuyButton = ({ items }: BuyButtonProps) => {
  const { mutate } = useShopifyCheckoutControllerCreateCheckout();

  const checkoutItems = items.map((item) => ({
    variantId: item.product?.variants[item.variantIdx]?.id,
    quantity: item.quantity,
  }));

  return (
    <StyledButton
      variant="contained"
      onClick={() =>
        mutate(
          {
            data: {
              items: checkoutItems,
            },
          },
          {
            onSuccess: (response) => {
              const { checkoutUrl } = response.data;
              if (checkoutUrl) {
                window.location.href = checkoutUrl;
              }
            },
            onError: (error) => {
              console.error("Failed to create checkout:", error);
            },
          },
        )
      }
    >
      Buy
    </StyledButton>
  );
};

export default BuyButton;
